export const sendDataToApp = (data, otherData = "", numTry = 0) => {
    sendDataToWebView(data, otherData, numTry)
    sendDataToGecko(data, otherData, numTry)
}

const sendDataToWebView = (data, otherData = "", numTry = 0) => {
    if (numTry === 2) {
        return;
    }

    try {
        if (typeof AndroidInterface !== "undefined") {
            AndroidInterface.sendDataToApp(data, otherData);
        }
    } catch (e) {
        setTimeout(() => sendDataToWebView(data, otherData, (numTry + 1)), 200);
    }
}

const sendDataToGecko = (data, otherData = "", numTry = 0) => {
    if (!window.clapshow) {
        return null;
    }

    if (numTry === 2) {
        return;
    }

    try {
        window.clapshow.postMessage(data, otherData);
    } catch (e) {
        setTimeout(() => sendDataToGecko(data, otherData, (numTry + 1)), 200);
    }
}